module.exports = __webpack_public_path__ + "img/gb-wls.040c4287.svg";